import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/lib/integration/react";
import Missing from "./Missing";
import Loader from "../Loader/Loader";
import { persister } from "../Reducers/store";
import ApplicationForm from "../Components/Services/CandidateLogin/AppplicationForm/ApplicationForm";
import KnowUserId from "../Auth/KnowUserId";
import ForgotPassword from "../Auth/ForgotPassword";
import ChangePassword from "../Auth/ChangePassword";
import { ProSidebarProvider } from "react-pro-sidebar";
import Preview from "../Components/Services/CandidateLogin/Posts/Preview";
import RequireAuth from "./RequireAuth";
import Unauthorized from "../Auth/Unauthorized";
import ProfilePage from "../Components/Services/CandidateLogin/RegistrationTabs/ProfilePage";

import PaymentStatus from "../Components/Services/CandidateLogin/Posts/PaymentStatus";
import SidebarNew from "../Components/Header/SidebarNew";
import Weboptions from "../Components/Services/CandidateLogin/WebOptions/Weboptions";
import FileUploads from "../Components/Services/CandidateLogin/AppplicationForm/FileUploads";
import AddService from "../Components/Services/RoleServices/AddService";
import SEPostVacancies from "../Components/Services/Reports/SEPostVacancies";
import REPostVacancies from "../Components/Services/Reports/REPostVacancies";
import HallTicketFinal from "../Components/Services/CandidateLogin/HallTicket/HallTicketFinal";
import ObjectionForm from "../Components/Services/CandidateLogin/ObjectionService/ObjectionForm";
import ObjectionReport from "../Components/Services/CandidateLogin/ObjectionService/ObjectionReport";
import AnsSheet from "../Components/Services/CandidateLogin/ObjectionService/AnsSheet";
import ProfileDetailsWay from "../Components/Services/CandidateLogin/ProfileDetailsWay";
import DashboardHome from "../Components/HomePage/DashboardHome";
import Results from "../Components/Services/CandidateLogin/Results/Results";
import TetObjections from "../Components/Services/CandidateLogin/ObjectionService/TetObjections";
import MeritList from "../Components/Services/CandidateLogin/Results/MeritList";
import DscVerificationCallLetter from "../Components/Services/CandidateLogin/Results/DscVerificationCallLetter";
import Order from "../Components/Services/CandidateLogin/Orders/Order";
import PostApplication from "../Components/Services/CandidateLogin/Posts/PostApplication";
import SelectionList from "../Components/Services/CandidateLogin/Results/SelectionList";
import FinalWebOptions from "../Components/Services/CandidateLogin/WebOptions/FinalWebOptions";
import SchoolVacancyReport from "../Components/Services/Reports/SchoolVacancyReport";
import RegistrationForm from "../Components/Services/CandidateLogin/RegistrationTabs/RegistrationForm";
import { CONTEXT_HEADING } from "../Components/CommonUtilities/Validations/RegularExpAndVar";
import PapersApplication from "../Components/Services/CandidateLogin/Papers/PapersApplication";
import CandidateDetailsBack from "../Components/Services/CandidateLogin/Payments/CandidateDetailsBack";
import CandidateProfile from "../Components/Services/CandidateLogin/AppplicationForm/CandidateProfile";
import PaymentInvoice from "../Components/Services/CandidateLogin/Payments/PaymentInvoice";
import PrintApplication from "../Components/Services/CandidateLogin/Posts/PrintApplication";
import TetPreview from "../Components/Services/CandidateLogin/Papers/TetPreview";
import TetPaymentStatus from "../Components/Services/CandidateLogin/Papers/TetPaymentStatus";
import TetPaymentInvoice from "../Components/Services/CandidateLogin/Payments/TetPaymentInvoice";
import Home1 from "../Components/HomePage/Home1";
import PreviousTetResults from "../Components/Services/PreviousTetResults";
import CandidateOldTetDetails from "../Components/Services/CandidateOldTetDetails";
import ChangeMobileNo from "../Components/Services/CandidateLogin/ChangeMobileNo";
import TetHallTicket from "../Components/Services/CandidateLogin/HallTicket/TetHallTicket";
import ResultsNew from "../Components/Services/CandidateLogin/Results/ResultsNew";
import TetResultsPrevious from "../Components/Services/TetResultsPrevious";
import ViewVacancies from "../Components/Services/CandidateLogin/Papers/ViewVacancies";
import CandidatesRegistrationReport from "../Components/Services/Reports/CandidatesRegistrationReport";
import DistwiseCandidatesReport from "../Components/Services/Reports/DistwiseCandidatesReport";
import TETPapersReport from "../Components/Services/Reports/TETPapersReport";
import TETDistPaperWiseReport from "../Components/Services/Reports/TETDistPaperWiseReport";
import DynamicShowReportNew from "../Components/CommonUtilities/CommonTable/DynamicShowReportNew";

const ROLES = {
  candidate: 1,
  emp: 2,
};
const RoutesComponent = () => (
  <PersistGate loading={null} persistor={persister}>
    <Router>
      <Routes>
        <Route path="/" element={<Home1/>} />
        <Route path="/Unauthorized" element={<Unauthorized />} />
        <Route path="/RegistrationForm" exact={true} element={<RegistrationForm />} />
        <Route path="/KnowUserId" exact={true} element={<KnowUserId />} />
        <Route path="/ForgotPassword" exact={true} element={<ForgotPassword />} />
        {/* <Route path="/UploadPdf" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<UploadPdf />} /> </ProSidebarProvider>} /> */}
        <Route path="/PaymentStatus" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<PaymentStatus />} /></ProSidebarProvider>} />
        <Route path="/TetPaymentStatus" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<TetPaymentStatus />} /></ProSidebarProvider>} />
        <Route element={<RequireAuth allowedRoles={[ROLES.candidate]} />}>
          <Route path="/ProfileDetailsWay" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<ProfileDetailsWay />} /> </ProSidebarProvider>} />
          <Route path="/ApplicationForm" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<ApplicationForm />} /> </ProSidebarProvider>} />
          <Route path="/HallTicketFinal" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<HallTicketFinal />} /></ProSidebarProvider>} />
          <Route path="/FinalWebOptions" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<FinalWebOptions />} /></ProSidebarProvider>} />
          <Route
            path="/FileUploads" exact={true}
            element={<ProSidebarProvider>
               <SidebarNew ChildForm={<FileUploads />} /> </ProSidebarProvider> }/>
          <Route path="/DscVerificationCallLetter" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<DscVerificationCallLetter />} /></ProSidebarProvider>} />
          <Route path="/Order" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<Order />} /></ProSidebarProvider>} />
          <Route
            path="/ApplicationForm"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ApplicationForm />} />{" "}
              </ProSidebarProvider>
            }
          />
          <Route
            path="/DashboardHome"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<DashboardHome />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/ChangePassword"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ChangePassword />} />{" "}
              </ProSidebarProvider>
            }
          />
          <Route
            path="/CandidateProfile"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<CandidateProfile />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/ProfilePage"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ProfilePage />} />
              </ProSidebarProvider>
            }
          />
          <Route path="/PostApplication" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<PostApplication />} /></ProSidebarProvider>} />
          <Route path="/Preview" exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<Preview />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/PrintApplication"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<PrintApplication />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/Weboptions"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<Weboptions />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/PaymentInvoice"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<PaymentInvoice />} />
              </ProSidebarProvider>
            }
          />
   {/* <Route path="/candidateBack" exact={true} element={ <ProSidebarProvider> {" "} <SidebarNew ChildForm={<CandidateDetailsBack />} /> </ProSidebarProvider> } /> */}
          <Route
            path="/ObjectionReport"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ObjectionReport />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/ObjectionForm"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ObjectionForm />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/AnsSheet"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<AnsSheet />} />
              </ProSidebarProvider>
            }
          />
          <Route
            path="/Results"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<Results />} />
              </ProSidebarProvider>
            }
          />
           
          <Route path="/TetPreview" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<TetPreview />} /></ProSidebarProvider>} />
          <Route path="/TetObjections" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<TetObjections />} /></ProSidebarProvider>} />
          <Route path="/SchoolVacancyReport" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<SchoolVacancyReport />} /></ProSidebarProvider>} />
          {/* <Route path="/HallTicketNew" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<HallTicketNew />} /></ProSidebarProvider>} /> */}
          {/* <Route path="/HallTicket" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<HallTicket />} /></ProSidebarProvider>} /> */}

          {/* *********************************TET APPLICATION ******************************************** */}
          <Route path="/PaperApplication" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<PapersApplication />} /></ProSidebarProvider>} />

          <Route path="/TetPaymentInvoice" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<TetPaymentInvoice />} /></ProSidebarProvider>} />
          <Route path="/CandidateOldTetDetails" exact={true} element={<ProSidebarProvider> <SidebarNew ChildForm={<CandidateOldTetDetails />} /></ProSidebarProvider>} />
          <Route path="/TetHallTicket" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<TetHallTicket />} /></ProSidebarProvider>} />

        </Route>

        <Route
          path="/AddService"
          exact={true}
          element={
            <ProSidebarProvider>
              {" "}
              <SidebarNew ChildForm={<AddService />} />
            </ProSidebarProvider>
          }
        />
        <Route
          path="/SEPostVacancies"
          exact={true}
          element={<SEPostVacancies />}
        />
        <Route
          path="/REPostVacancies"
          exact={true}
          element={<REPostVacancies />}
        />
        <Route path="/SelectionList" exact={true} element={<SelectionList />} />
        <Route path="/MeritList1" exact={true} element={<MeritList />} />
        <Route path="*" element={<Missing />} />
        <Route path="/PreviousTetResults" exact={true} element={<PreviousTetResults />} />
         <Route path="/TetResultsPrevious" exact={true} element={<TetResultsPrevious />} />
        <Route path="/ChangeMobileNo" exact={true} element={<ChangeMobileNo />} />
        <Route
            path="/ViewVacancies"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ViewVacancies />} />
              </ProSidebarProvider>
            }
          />
       
        <Route
            path="/ResultsNew"
            exact={true}
            element={
              <ProSidebarProvider>
                {" "}
                <SidebarNew ChildForm={<ResultsNew />} />
              </ProSidebarProvider>
            }
          />
            {/* *********************************KGBV REPORTS ******************************************** */}
     <Route path="/CandidatesRegistrationReport" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<CandidatesRegistrationReport />} /></ProSidebarProvider>} />  
      <Route path="/DistwiseCandidatesReport" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<DistwiseCandidatesReport />} /></ProSidebarProvider>} />    
       <Route path="/TETPapersReport" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<TETPapersReport />} /></ProSidebarProvider>} />  
       <Route path="/TETDistPaperWiseReport" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<TETDistPaperWiseReport />} /></ProSidebarProvider>} />    

        <Route path="/show-report" exact={true} element={<ProSidebarProvider><SidebarNew ChildForm={<DynamicShowReportNew/>} /></ProSidebarProvider>} />    
      
      
      </Routes>
      <Loader />
    </Router>
  </PersistGate>
);
export default RoutesComponent;
